import React, { useEffect, useState } from "react";
import "./Agreements.css";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";

import Header2 from "../../Components/Header2/Header2";
import { useUser } from "../../Context/UserContext";
import useAPI from "../../Hooks/useAPI";
import { getContractsArchiveUrl } from "../../config";
import { useNavigate } from "react-router-dom";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Define  agreement record
interface Agreements {
  agreementid: number;
  agreementtypeid: number;
  agreementtypecode: string;
  agreementtypedescr: string;
  requesteremail: string;
  fullname: string;
  streetaddress: string;
  city: string;
  state: string;
  zip: string;
  signature: string;
  signertitle: string;
  requesteddate: string;
  agreementcode: string;
  agreementstatus: string;
  reviewername: string;
  pdffilename: string;
  businessname: string;
  datereviewed: string;
  externaluserid: string;
}

const Agreements: React.FC = () => {
  const { user } = useUser();
  const [agreements, setAgreements] = useState<Agreements[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");

  const ContractsArchiveUrl = getContractsArchiveUrl();
  const { getUserAgreements } = useAPI();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAgreements = async () => {
      try {
        const response = await getUserAgreements(
          user!.id,
          0,
          "All",
          user!.cidn ?? 0
        );

        if (response?.data) {
          setAgreements(response.data);
        } else {
          throw new Error("Failed to fetch agreements");
        }
      } catch (error) {
        setError(error instanceof Error ? error.message : "An error occurred");
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgreements();
  }, []);

  const handleAdd = () => {
    navigate("/contracts-home");
  };

  const getStatusStyle = (status: string) => {
    if (status.toLowerCase().includes("rejected")) {
      return { color: "red" };
    } else if (status.toLowerCase().includes("approved")) {
      return { color: "green" };
    } else if (status.toLowerCase().includes("pending")) {
      return { color: "orange" };
    } else {
      return {};
    }
  };

  return (
    <div className="generalPage agreements">
      <Header2 />
      <div id="Agreements" className="sectionContainer">
        <div className="agreements-container">
          <div className="pageContainer">
            <div className="agreements-header">
              <div className="agreements-actions">
                <h1 className="agreements-title">My Agreements</h1>
              </div>
              <div className="agreements-actions">
                <button onClick={handleAdd} className="add-agreement-button">
                  Create New Agreement
                </button>
              </div>
              <div className="Agreements-table-container">
                {error && <div className="error-text">{error}</div>}
                {loading ? (
                  <p></p>
                ) : (
                  <table className="Agreements-table">
                    <thead className="Agreements-table-header">
                      <tr>
                        <th>Type</th>
                        <th>Signer's Name</th>
                        <th>
                          Date
                          <br />
                          Submitted
                        </th>
                        <th>Requestor's Email</th>
                        <th>Entity</th>
                        <th>Status</th>
                        <th>File Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {agreements && agreements.length > 0 ? (
                        agreements.map((agreements) => {
                          return (
                            <tr
                              key={agreements.agreementid}
                              className="Agreements-table-row"
                            >
                              <td title={agreements.agreementtypedescr}>
                                {agreements.agreementtypecode}
                              </td>
                              <td>{agreements.signature}</td>
                              <td>
                                {new Date(
                                  agreements.requesteddate
                                ).toLocaleDateString()}
                              </td>
                              <td>{agreements.requesteremail}</td>
                              <td>{agreements.fullname}</td>
                              <td
                                style={getStatusStyle(
                                  agreements.agreementstatus
                                )}
                              >
                                {agreements.agreementstatus}
                              </td>

                              <td>
                                {agreements.pdffilename &&
                                agreements.pdffilename.trim() !== "" ? (
                                  <a
                                    href={
                                      ContractsArchiveUrl +
                                      agreements.pdffilename
                                    }
                                    target="_blank"
                                    className="underline-link"
                                    title={agreements.pdffilename} // tooltip shows filename
                                  >
                                    View PDF
                                  </a>
                                ) : null}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "center" }}>
                            No Agreements found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Agreements;
